import script from "./PlaExpedicaoEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaExpedicaoEditPage.vue?vue&type=script&setup=true&lang=js"

import "./PlaExpedicaoEditPage.vue?vue&type=style&index=0&id=08ad83b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ad83b2"]])

export default __exports__